import React from 'react'
import { Icon } from '@chakra-ui/react'

const LeftArrow = ({ color = '#ffffff', ...props }) => {
  return (
    <svg
      width="20"
      height="10"
      viewBox="0 0 20 10"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      {...props}
    >
      <path
        d="M0.244167 4.22568L4.22583 0.244013C4.46416 0.00575645 4.82253 -0.0655052 5.13388 0.0634481C5.44523 0.192401 5.64826 0.496183 5.64833 0.83318V3.35651C5.64833 3.47157 5.74161 3.56485 5.85667 3.56485H18.75C19.4404 3.56485 20 4.12449 20 4.81485C20 5.5052 19.4404 6.06485 18.75 6.06485H5.85667C5.74161 6.06485 5.64833 6.15812 5.64833 6.27318V8.79651C5.64826 9.13351 5.44523 9.43729 5.13388 9.56625C4.82253 9.6952 4.46416 9.62394 4.22583 9.38568L0.244167 5.40401C-0.0811501 5.0786 -0.0811501 4.5511 0.244167 4.22568Z"
        // fill="#83B53C"
      />
    </svg>
  )
}

export default LeftArrow
